import React from 'react';
export const Quotes = () => {
  return <div className="py-10 md:py-16 bg-gray-50 relative" data-id="element-192">
      {/* Stars and stripes background element */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-5 pointer-events-none" data-id="element-193">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-194"></div>
      </div>
      <div className="container mx-auto px-3 md:px-4 max-w-4xl relative z-10" data-id="element-195">
        <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-8 flex items-center" data-id="element-196">
          <span className="text-blue-700 mr-2" data-id="element-197">★</span>
          Quotes that made headlines
          <span className="text-red-700 ml-2" data-id="element-198">★</span>
        </h2>
        <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-8" data-id="element-199">
          Kirk mastered the art of short, powerful statements that championed
          American values—perfect for the viral age:
        </p>
        <div className="grid gap-3 md:gap-6 md:grid-cols-1 mb-8 md:mb-12" data-id="element-200">
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md border-l-4 border-red-700" data-id="element-201">
            <blockquote className="text-lg md:text-xl italic font-medium text-gray-800 mb-3 md:mb-4" data-id="element-202">
              "Freedom is not free. It comes with responsibility and sacrifice."
            </blockquote>
            <div className="flex justify-end" data-id="element-203">
              <div className="w-8 h-2 bg-blue-700" data-id="element-204"></div>
            </div>
          </div>
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md border-l-4 border-white border-r-4 border-r-blue-700" data-id="element-205">
            <blockquote className="text-lg md:text-xl italic font-medium text-gray-800 mb-3 md:mb-4" data-id="element-206">
              "If you win the classroom, you win the culture. If you win the
              culture, you win the nation."
            </blockquote>
            <div className="flex justify-end" data-id="element-207">
              <div className="w-8 h-2 bg-red-700" data-id="element-208"></div>
            </div>
          </div>
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md border-l-4 border-blue-700" data-id="element-209">
            <blockquote className="text-lg md:text-xl italic font-medium text-gray-800 mb-3 md:mb-4" data-id="element-210">
              "Without God, the state becomes God. And that's the path to
              tyranny."
            </blockquote>
            <div className="flex justify-end" data-id="element-211">
              <div className="w-8 h-2 bg-red-700" data-id="element-212"></div>
            </div>
          </div>
        </div>
        <p className="text-base md:text-lg text-gray-700 font-medium text-center" data-id="element-213">
          These aren't just words. They're battle cries for America's future.
        </p>
      </div>
    </div>;
};